export const navbarLinks = [
  { name: "News", href: "/news" as const },
  { name: "Mannschaften", href: "/teams" as const },
  { name: "Tabelle", href: "/tabelle" as const },
  { name: "Termine", href: "/termine" as const },
  { name: "Fotos", href: "/fotos" as const },
  {
    name: "Shop",
    href: "https://vcmuellheim.fan12.de/kategorien/vereinskollektion" as const,
    target: "_blank" as const,
    rel: "noreferrer" as const,
  },
  { name: "Kontakt", href: "/#kontakt" as const },
];

/** Mobile-only nav entry — omitted from desktop header due to space constraints. */
export const mobileOnlyNavbarLinks = [{ name: "Live", href: "/live" as const }] as const;
